import { useConfig } from "@jti/app-context/useConfig";
import { ConsumablesProductDetailsContainer as UiConsumablesProductDetailsContainer } from "@jti/product-details/consumables-product-details";
import { useTranslations } from "@jti/ui/providers/useTranslations";

import type { ConsumablesProductDetailsContainerProps } from "./ConsumablesProductDetailsContainer.inputs.builder";

export function ConsumablesProductDetailsContainer(props: ConsumablesProductDetailsContainerProps) {
  const { DISABLE_COMMERCE, enableSubscriptions, defaultProductCtaLabel, defaultProductCtaUrl } = useConfig();
  const { __ } = useTranslations();

  return (
    <UiConsumablesProductDetailsContainer
      {...{
        sku: props.sku ?? "",
        badgeText: __("product.badge.new"),
        overwriteBadgeText: props.overwriteBadgeText ?? "",
        loyaltyBadgeCopy: props.loyaltyDiscountBadgeCopy,
        loyaltyRewardCopy: props.loyaltyRewardCopy,
        isLoyaltyRewardCopyAuthoringEnabled: props.isLoyaltyRewardCopyAuthoringEnabled ?? false,
        description: props.description ?? "",
        shortDescription: props.shortDescription ?? "",
        knowMoreUrl: props.knowMoreUrl ?? "",
        multiPackDescription: props.multiPackDescription ?? "",
        productCta: {
          label: props.productCta?.label || defaultProductCtaLabel || "",
          url: props.productCta?.url || defaultProductCtaUrl || "",
        },
        productName: props.productName ?? "",
        hasBadge: props.hasBadge ?? false,
        hasDiscountBadge: props.hasDiscountBadge ?? false,
        hasLoyaltyDiscountBadge: props.hasLoyaltyDiscountBadge ?? false,
        hasStrikethroughPrice: props.hasStrikethroughPrice ?? false,
        hideCta: props.hideCta ?? false,
        isCommerceDisabled: !!DISABLE_COMMERCE,
        isMultiPackEnabled: props.isMultiPackEnabled ?? false,
        hidePrice: props.hidePrice ?? false,
        isPriceDropdownEnabled: props.isPriceDropdownEnabled ?? false,
        priceDropdownPromotionalMessage: props.priceDropdownPromotionalMessage ?? "",
        priceDropdownPromotionalTooltip: props.priceDropdownPromotionalTooltip ?? "",
        multiPackName: props.multiPackName ?? "",
        multiPackProducts: props.multiPackProducts ?? [],
        customBuyCtaLabel: props.customBuyCtaLabel ?? "",
        consumablesMatrixData: {
          packagingFormats: props.consumablesMatrixData?.packagingFormats ?? [],
          items: props.consumablesMatrixData?.items ?? [],
        },
        isSubscriptionsEnabled: enableSubscriptions ?? false,
      }}
    />
  );
}
